/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface CreateMessageDto
 */
export interface CreateMessageDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageDto
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageDto
     */
    adminNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageDto
     */
    status?: CreateMessageDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateMessageDtoStatusEnum {
    Pending = 'Pending',
    Read = 'Read',
    Resolved = 'Resolved',
    Archived = 'Archived'
}

